import { forkProject as _forkProject } from '~/lib/.client/api/projects';
import { createChat } from '~/lib/persistence/chats';
import { duplicateIntegrations } from '~/lib/persistence/duplicateApi';
import { getDescription } from '~/lib/stores/description';
import { projectStore } from '~/lib/stores/project';
import { userStore } from '~/lib/stores/user';
import { workbenchStore } from '~/lib/stores/workbench';
import { invariant } from '~/utils/invariant';
import { navigateToStackblitzProject } from '~/utils/navigate';

export function forkProject() {
  return withNewProject(async (slug) => {
    const activeOrganization = userStore.getActiveOrganization().get();

    const newProject = await _forkProject({
      slug,
      files: workbenchStore.files.get(),
      activeOrganization,
    });

    projectStore.updateProject(newProject, activeOrganization);

    navigateToStackblitzProject(newProject.slug);

    projectStore.setShouldFork(false, activeOrganization);
  });
}

export async function duplicateProject() {
  return withNewProject(async (slug, fromProjectId) => {
    const newProject = await _forkProject({
      slug,
      files: workbenchStore.files.get(),
      activeOrganization: userStore.getActiveOrganization().get(),
    });

    await duplicateIntegrations(fromProjectId, newProject.id);

    await createChat({
      projectId: newProject.id,
      description: getDescription(),
      activeOrganization: newProject.organization,
    });

    window.location.href = new URL(`/~/${newProject.slug}`, window.origin).toString();
  });
}

async function withNewProject(cloneProject: (slug: string, projectId: string) => Promise<void>) {
  try {
    projectStore.isForking.set(true);

    const oldSlug = projectStore.getSlug();
    const oldProjectId = projectStore.getProjectId();

    invariant(oldSlug);
    invariant(oldProjectId);

    await cloneProject(oldSlug, oldProjectId);
  } finally {
    projectStore.isForking.set(false);
  }
}
